import { ExternalLink } from "lucide-react";

const references = [
  {
    label: "Spamhaus Domain Blocklist (DBL)",
    url: "https://www.spamhaus.org/blocklists/domain-blocklist/",
  },
  {
    label: "Spamhaus Domain Blocklist FAQs",
    url: "https://www.spamhaus.org/faqs/domain-blocklist/",
  },
  {
    label:
      "Spamhaus research: how bulk domain registration aids global spam campaigns",
    url: "https://www.spamhaus.org/resource-hub/domain-reputation/weaponizing-domain-names-how-bulk-registration-aids-global-spam-campaigns/",
  },
  {
    label: "Postmark: the hype and truth about email blocklists",
    url: "https://postmarkapp.com/support/article/the-hype-and-truth-about-email-blocklists",
  },
  {
    label: "SURBL overview",
    url: "https://en.wikipedia.org/wiki/SURBL",
  },
];

export const EmailBlacklistsReferences = () => {
  return (
    <section className="mt-12 sm:mt-16">
      <h2 className="font-display text-xl font-semibold text-foreground mb-4">References</h2>
      <ul className="space-y-2.5">
        {references.map((ref) => (
          <li key={ref.url}>
            <a
              href={ref.url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-start gap-2 text-sm text-primary hover:text-primary/80 transition-colors"
            >
              <ExternalLink className="w-4 h-4 mt-0.5 flex-shrink-0" />
              {ref.label}
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
};